<template>
  <b-overlay
    :show="loading"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <!-- List users -->
    <b-card
      v-if="id"
      no-body
      aria-hidden="true"
      :title="`Thay đổi người dùng trong nhóm:  ${itemData.name} `"
    >
      <b-card-header class="p-1">
        <h3 class="card-title mb-0">
          Thay đổi người dùng trong nhóm: {{ itemData.name }}
        </h3>
      </b-card-header>
      <b-card-body style="padding: 0 1rem 1rem 1rem;">
        <b-row class=" mb-2">
          <b-col
            cols="12"
            md="6"
          >
            <b-input-group>
              <b-form-input
                v-model="searchUserQuery"
                class="d-inline-block"
                placeholder="Từ khóa"
                @keydown.enter="fetchGroupUsers($event)"
              />
              <b-input-group-append>
                <b-button
                  variant="primary"
                  @click.prevent.stop="fetchGroupUsers"
                >
                  <feather-icon icon="SearchIcon" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
            class="text-right"
          >
            <b-button
              v-b-modal.modalListUser
              variant="outline-primary"
              size="sm"
            >
              <feather-icon icon="PlusIcon" /> Thêm thành viên </b-button>
          </b-col>
        </b-row>
        <!-- Table list users -->
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="userItems"
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          responsive
          show-empty
          empty-text="Không tìm thấy kết quả"
          :sort-desc.sync="isSortDirDesc"
        >
          <!-- Column: User -->
          <template #cell(user)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                  size="32"
                  :src="defaultAvatar(data.item.avatar)"
                  :text="avatarText(data.item.username)"
                  variant="light-primary"
                />
              </template>
              <span class="font-weight-bold d-block text-nowrap"> {{ data.item.full_name }} </span>
              <small class="text-muted">{{ data.item.username }}</small>
            </b-media>
          </template>
          <!-- Column: Department -->
          <template #cell(department)="data">
            <span
              v-if="data.item.department"
              class="font-weight-bold d-block"
            >{{ data.item.department.name }}</span>
          </template>
          <!-- Column: Position -->
          <template #cell(position)="data">
            <span
              v-if="data.item.position"
              class="font-weight-bold text-capitalize d-block"
            >{{ data.item.position.name }}</span>
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-button
              v-if="$can('group.addUser', 'Group')"
              size="sm"
              class="ml-1"
              variant="outline-danger"
              @click="toggleAddUser(data.item)"
            >
              <span class="text-nowrap">
                <feather-icon icon="TrashIcon" />
              </span>
            </b-button>
          </template>
        </b-table>
        <!-- Paginate -->
        <div class="mt-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('show_to_entries', { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of }) }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalEntries"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
    <!-- Modal list user -->
    <b-modal
      id="modalListUser"
      title="Danh sách người dùng"
      size="xl"
      :ok-only="true"
      ok-title="Đóng"
    >
      <groups-list-user :group-id="itemData.id" />
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BRow, BCol, BCard, BAvatar, BOverlay, BButton, BFormInput,
  BTable, BPagination, BInputGroup, BInputGroupAppend,
  BMedia, BCardHeader, BCardBody,
} from 'bootstrap-vue'
import {
  ref, watch, onMounted, computed,
} from '@vue/composition-api'
import store from '@/store'
import { useRouter, defaultAvatar } from '@core/utils/utils';
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import { avatarText } from '@core/utils/filter'
import GroupsListUser from './GroupsListUser.vue'
import useGroups from './useGroups';

export default {
  components: {
    GroupsListUser,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,
    BOverlay,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BAvatar,
    BMedia,
    BCardHeader,
    BCardBody,
  },
  directives: {
    Ripple,
  },
  props: {
    groupData: {
      type: Object,
      default: () => { },
    },
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const id = ref(route.value.params.id !== undefined ? route.value.params.id : 0);
    const layout = ref(route.value.name !== 'groups-edit' ? 'add' : 'edit');
    const errorMessage = ref('')
    const groups = ref([])
    const userItems = ref([])
    const perPage = ref(10);
    const totalEntries = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const sortBy = ref('id');
    const isSortDirDesc = ref(true);

    const dataMeta = computed(() => ({
      from: perPage.value * (currentPage.value - 1) + (userItems.value.length ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + userItems.value.length,
      of: totalEntries.value,
    }));

    const defaultItemData = {
      name: '',
      description: '',
    }
    const tableColumns = [
      { key: 'id', sortable: true, thAttr: { width: '6%' } },
      {
        key: 'user',
        sortable: true,
        label: 'Tên đăng nhập',
      },
      {
        key: 'department',
        label: 'Phòng ban',
        sortable: false,
        thAttr: { width: '15%' },
      },
      {
        key: 'position',
        sortable: false,
        label: 'Vị trí',
        thAttr: { width: '15%' },
      },
      {
        key: 'actions',
        label: 'Hành động',
        thAttr: { width: '150' },
        thClass: 'text-center',
        tdClass: 'text-center',
      },
    ];
    const {
      loading,
      searchUserQuery,
      reloadUserGroupList,
      addUserToGroup,
      assignUserToGroup,
    } = useGroups()

    const itemData = ref(JSON.parse(JSON.stringify(defaultItemData)))

    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(defaultItemData))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetItemData)

    const fetchGroupUsers = () => {
      loading.value = true;
      store
        .dispatch('groups/fetchGroupUsers', {
          id: id.value,
          params: {
            keyword: searchUserQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            isPaginate: 1,
          },
        })
        .then((response) => {
          loading.value = false;
          if (response.status === 200) {
            const items = response.data.data.data;
            const { total } = response.data.data;
            totalEntries.value = total;
            userItems.value = items;
          }
        });
    };

    fetchGroupUsers();

    onMounted(() => {
      context.root.$on('bv::modal::shown', (bvEvent, modalId) => {
        // console.log('reloadUserGroupList', reloadUserGroupList.value);
        if (modalId === 'modalListUser') {
          store.dispatch('groups/SET_RELOAD_USER_LIST', false);
        }
      })
      context.root.$on('bv::modal::hidden', (bvEvent, modalId) => {
        // console.log(modalId, 'modalListUser', reloadUserGroupList.value);
        if (modalId === 'modalListUser' && reloadUserGroupList.value) {
          fetchGroupUsers();
        }
      })
    });

    watch([currentPage, perPage], () => {
      fetchGroupUsers();
    });

    // watch(
    //   () => context.root.$route,
    //   (to) => {
    //     id.value = route.value.params.id !== undefined ? route.value.params.id : 0;
    //     if (to.name === 'groups-add') {
    //       context.emit('reset-form')
    //     } else {
    //       context.emit('fetch-data')
    //     }
    //   },
    // )

    return {
      id,
      layout,
      errorMessage,
      loading,
      itemData,
      groups,
      refFormObserver,
      userItems,
      tableColumns,
      getValidationState,
      resetForm,
      resetItemData,
      fetchGroupUsers,
      dataMeta,
      perPageOptions,
      perPage,
      currentPage,
      totalEntries,
      sortBy,
      isSortDirDesc,
      searchUserQuery,
      reloadUserGroupList,
      addUserToGroup,
      assignUserToGroup,
      avatarText,
      defaultAvatar,
    }
  },
  methods: {
    toggleAddUser(user) {
      this.$swal({
        text: 'Bạn chắc muốn xóa tài khoản này khỏi nhóm?',
        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.assignUserToGroup(
            this.$route.params.id,
            {
              userId: user.id,
            },
            () => {
              this.fetchGroupUsers();
            },
          )
        }
      })
    },
  },
}
</script>

<style></style>
